import React from 'react';
import smoothScroll from 'smoothscroll';

export default class ScrollLink extends React.Component {
  constructor(props) {
    super(props);

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.onClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    const $target = document.querySelector(this.props.target);
    event.preventDefault();

    if ($target) {
      let $firstLink = $target.querySelector('a');

      smoothScroll($target, 1000);

      if ($firstLink) {
        $firstLink.focus();
      }
    }
  }

  render() {
    return (
      <a href="#" className={this.props.className} onClick={this.onClick}>
        {this.props.children}
        <span className="isVisuallyHidden">Scroll To Page Section</span>
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/components/scroll-link.jsx